<div class="page-root-center">
  <div class="page-column">
    @if (showMigration) {
      <mat-card>
        <mat-card-header>
          <mat-card-title>{{ "login.info.title" | transloco }}</mat-card-title>
        </mat-card-header>

        <mat-card-content>
          <div class="column">
            <p class="info-flex">{{ "login.info.description.intro" | transloco }}</p>
            <div class="info-row">
              <p>{{ "login.info.description.migrate_admin" | transloco }}</p>
              <button class="button-flex" mat-flat-button (click)="migrateAdmin()">{{ "login.migrate_admin.title" | transloco}}</button>
            </div>
            <div class="info-row">
              <p class="info-flex">{{ "login.info.description.lookup_customer_id" | transloco }}</p>
              <button class="button-flex" mat-flat-button (click)="lookupCustomerId()">{{ "login.lookup_customer_id.title" | transloco}}</button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    }
    <mat-card>
      <mat-card-header>
        <mat-card-title>{{ "login.title" | transloco }}</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <form (ngSubmit)="login()" [formGroup]="loginForm">
          <div class="dialog-root">
            @if (customerIdSelector) {
              <mat-form-field hideRequiredMarker="true">
                <mat-label>{{ "form.label.customer_id" | transloco}}</mat-label>
                <input [formControl]="customerIdSelector" matInput type="number">
              </mat-form-field>
            }

            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{ "form.label.email" | transloco}}</mat-label>
              <input formControlName="email" matInput type="text">
            </mat-form-field>

            <mat-form-field hideRequiredMarker="true">
              <mat-label>{{ "form.label.password" | transloco}}</mat-label>
              <input [type]="hidePassword ? 'password' : 'text'" formControlName="password" matInput>
              <button (click)="togglePasswordVisibility()" mat-icon-button matSuffix type="button">
                <mat-icon>{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon>
              </button>
            </mat-form-field>

            @if (error) {
              <mat-error>{{ error }}</mat-error>
            }

            <button mat-flat-button type="submit">{{ "login.button" | transloco}}</button>

            <div class="card-footer-text">
              {{ "login.reset_password.prefix" | transloco}}
              <span (click)="resetPassword()" class="clickable-text">{{ "login.reset_password.navigation" | transloco}}</span>
              {{ "login.reset_password.suffix" | transloco}}
            </div>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
